import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";

const logLevelMap: Record<string, LogLevel> = {
  error: LogLevel.Error,
  warning: LogLevel.Warning,
  info: LogLevel.Info,
  verbose: LogLevel.Verbose,
};

const entraLogLevel =
  logLevelMap[import.meta.env.VITE_ENTRA_LOG_LEVEL || "info"];

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || "";
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "";
const redirectUri =
  window.origin ||
  import.meta.env.VITE_AZURE_REDIRECT_URI ||
  "http://localhost:3001";

if (!clientId || !tenantId) {
  console.error(
    "Azure AD configuration is missing. Please set VITE_AZURE_CLIENT_ID and VITE_AZURE_TENANT_ID in your environment variables.",
  );
}

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean,
      ) => {
        if (containsPii) return;

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
      logLevel: entraLogLevel,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const apiRequest = {
  scopes: [`api://${clientId}/dash`],
};
